import { mergeWith } from "lodash";
import { twMerge } from "tailwind-merge";

export const mergePt = <T>(defaults: T, custom: unknown): T =>
    mergeWith({}, defaults, custom, (defaultValue, customValue, key) => {
        if (key === "className") {
            return twMerge(defaultValue, customValue);
        }
        return undefined;
    });
